import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import TreeView from '../../portal/treeView';
import SearchBoxContainer from '../../portal/searchBoxContainer';
import { toJS } from 'mobx';

@inject('teamsStore', 'usersStore') @observer
export default class TeamsTreeView extends Component {

    constructor(props){
        super(props);

        this.state = {
            filterValue: ''
        };
        
        this.props.teamsStore.displayedTeams = this.props.teamsStore.teams;
        this.props.teamsStore.expandedTeams = undefined;
    };

    searchTeams = (value) => {
        this.setState({filterValue: value ? value : ''});
        this.props.teamsStore.searchTeams(value);
    };

    filterTreeNode = (node) => {

        var filterValue = this.state.filterValue.trim();
        if(!filterValue || filterValue.toLowerCase().trim().length === 0)
            return false;
            
        return node.props.title.toLowerCase().includes(filterValue.toLowerCase());
    };

    teamExpand = (expandedKeys, options) => {
        this.props.teamsStore.setExpandedTeams(expandedKeys);
    };

    getExpandedTeams(){
        let expandedTeams = [];

        if(this.props.teamsStore.expandedTeams){
            expandedTeams = toJS(this.props.teamsStore.expandedTeams);
        }
        else
        {
            const rootTeamId = this.props.teamsStore.teams[0].id;
            expandedTeams = this.props.teamsStore.teams.filter((team)=> team.parentId == rootTeamId).map((team) => `${team.id}`);
            expandedTeams.push(`${rootTeamId}`);
        }

        return expandedTeams;
    }

    render() {

        if (this.props.teamsStore.displayedTeams == null) {
            return null;
        }

        let expandedTeams = this.getExpandedTeams();        

        return (
            <div className='user-form-teamtree-wrapper'>
                <SearchBoxContainer  
                    search={this.searchTeams}
                    dataCy='teams-tree-view-searchbox'>                   
                </SearchBoxContainer>
                <TreeView 
                    dataCy='teams-tree-view'
                    className='portal-tree-view'
                    selectedKeys={this.props.selectedKeys} 
                    checkedHandler={this.props.checkedHandler} 
                    checkedKeys={this.props.checkedKeys} 
                    checkStrictly={this.props.checkStrictly}
                    selectable={this.props.selectable}
                    checkable={this.props.checkable}
                    draggable={this.props.draggable}
                    onSelect={this.props.onSelect}
                    nodes={this.props.teamsStore.buildTeamTree}
                    onDragStart={this.props.onDragStart}
                    onDragEnter={this.props.onDragEnter}
                    onDrop={this.props.onDrop}
                    onRightClick={this.props.onRightClick}
                    defaultExpandParent={false}
                    defaultExpandAll={false}
                    expandedKeys={expandedTeams}
                    filterTreeNode={this.filterTreeNode}
                    onExpand = {this.teamExpand}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/teams/teamsTreeView/index.jsx